<template>
<el-dialog title="选择供应商" :visible.sync="dialogVisible" width="35%" :append-to-body="true" :center="true" :wrapperClosable="false">
    <el-form label-width="120px">
        <el-form-item label="请选择供应商">
            <el-select v-model="supplier_id">
                <el-option v-for="(item,index) in suppliers" placeholder="请选择供应商" :key="index" :label="item.title" :value="item.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="总价格">
            <el-input v-model="product_pirce" placeholder="请输入价格"></el-input>
        </el-form-item>
        <el-form-item label="备注">
            <el-input v-model="remark" type="textarea" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">确认</el-button>
            <el-button @click="closeDrawer">取消</el-button>
        </el-form-item>
    </el-form>
</el-dialog>
</template>

<script>
export default {
    props: {
        parent: {}
    },
    data() {
        return {
            supplier_id: '',
            dialogVisible: false,
            // ruleForm: Object.assign({}, ruleForm),
            suppliers: [],
            forms: [],
            cid: 0,
            applyItem: {},
            product_pirce: '',
            remark: ''
        }
    },
    methods: {
        showDialog(suppliers, applyItem) {
            this.suppliers = suppliers;
            this.dialogVisible = true;
            // this.cid = cid;
            // this.forms = forms;
            this.applyItem = applyItem;
            this.supplier_id = '';
            this.product_pirce = '';
            this.remark = ''
        },
        // 先保留吧,使用的地方太多了
        closeDrawer() {
            this.dialogVisible = false;
        },
        submit() {
            if (this.supplier_id == '') {
                this.$message({
                    type: 'danger',
                    message: '请选择供应商'
                });
                return false;
            }

            // let id = 'category_' + this.cid;
            let target = this.suppliers.find(ele => ele.id == this.supplier_id);
            let status = {
                "status": 1,
                'stitle': '已分配'
            }
            target = Object.assign(target, status);
            let priceTarget = {
                price: this.product_pirce
            }
            priceTarget = Object.assign({}, priceTarget);
            // return false
            if (target || priceTarget) {
                this.applyItem.supplier = target;
                this.applyItem.product = priceTarget;
                this.applyItem.remark = this.remark;
                this.parent.$forceUpdate();
                this.dialogVisible = false;
            }
        }
    }
}
</script>
